import { parseUrl } from 'query-string'

import { pick } from 'shared/utils/objectUtils'

export const SEARCH_PARAMS = ['query', 'queryID', 'position']

export const extractSearchParams = url => {
  return pick(parseUrl(url).query, SEARCH_PARAMS)
}
